import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createBlock(_component_BaseButton, {
    label: "Delete",
    "background-color": "red",
    color: "white",
    "font-size": 14,
    icon: "trash",
    "icon-padding-bottom": 1,
    "icon-size": 14,
    "border-color": "light-red",
    width: 90,
    height: 24,
    "padding-horizontal": 12,
    enabled: _ctx.enabled,
    "on-click": _ctx.onClick
  }, null, 8, ["enabled", "on-click"]))
}